// Module
var code = "<div class=\"wait center\"></div>";
// Exports
module.exports = code;